export const environment = {
    production: false,
    mediaAssetsUrl:'/assets/images/',
    backendUrl: "https://wow-gateway-co9sxgig.ue.gateway.dev"
}